/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalEl} from 'common/components/modal';
import {SpinnerEl} from 'common/components/spinner';
import {SpinnerSize} from 'common/components/spinner/types';

import type {TutorialVideoModal} from './index';

export function template(this: TutorialVideoModal) {
  const tutorialUrl = this.attr(`custom-url`) || `https://www.youtube.com/embed/PbKnQ777vuk`;
  const title = this.attr(`title`);

  return (
    <ModalEl
      sel='#media-modal'
      attrs={{
        open: this.state.isModalOpen,
        closeable: true,
        'modal-title': title,
        'grow-to-content': true,
      }}
    >
      <div sel='.modal-container'>
        <div sel='.modal-title'>{title}</div>

        <div sel='.modal-content'>
          <div sel='.video-container'>
            <SpinnerEl sel='#tutorial-spinner' attrs={{size: SpinnerSize.Large}} />
            <iframe
              sel='#tutorial-iframe'
              attrs={{
                frameborder: `0`,
                allow: `autoplay`,
                src: tutorialUrl,
                width: this.attr(`width`) || 560,
                height: this.attr(`height`) || 315,
                allowfullscreen: true,
              }}
            />
          </div>
        </div>
      </div>
    </ModalEl>
  );
}
